"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addText = addText;
exports.replaceText = replaceText;
exports.defaultRenderSelect = exports.getCurrentLine = void 0;

var _draftJs = require("draft-js");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getCurrentLine = editorState => {
  const {
    anchorOffset
  } = editorState.getSelection();
  const selection = editorState.getSelection().merge({
    anchorOffset
  });
  const key = editorState.getSelection().getStartKey();
  return editorState.getCurrentContent().getBlockForKey(key).getText().slice(0, selection.getFocusOffset());
};

exports.getCurrentLine = getCurrentLine;

function addText(editorState, bufferText) {
  const contentState = _draftJs.Modifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), bufferText);

  return _draftJs.EditorState.push(editorState, contentState, "insert-characters");
}

function replaceText(editorState, bufferText) {
  const contentState = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), bufferText);

  return _draftJs.EditorState.push(editorState, contentState, "insert-characters");
}

const defaultRenderSelect = (_ref) => {
  let {
    options,
    onChange,
    selectedValue
  } = _ref;
  return _react.default.createElement("select", {
    value: selectedValue,
    onChange: onChange
  }, options.map((_ref2) => {
    let {
      label,
      value
    } = _ref2;
    return _react.default.createElement("option", {
      key: value,
      value: value
    }, label);
  }));
};

exports.defaultRenderSelect = defaultRenderSelect;